import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CountUpModule } from 'ngx-countup';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../shared/shared.module';
import { BannerComponent } from './banner/banner.component';
import { ProductInfoComponent } from './product-info/product-info.component';
import {FeaturesComponent} from './features/features.component';
import {PartnersComponent} from './partners/partners.component';
import {ComingSoonModule} from "../coming-soon/coming-soon.module";
import {PageCtaComponent} from "./page-cta/page-cta.component";


@NgModule({
    declarations: [
        PartnersComponent,
        FeaturesComponent,
        HomeComponent,
        BannerComponent,
        ProductInfoComponent,
        PageCtaComponent
    ],
    exports: [
        PageCtaComponent
    ],
    imports: [
        CommonModule,
        HomeRoutingModule,
        SharedModule,
        NgbModule,
        CountUpModule,
        SlickCarouselModule,
        ComingSoonModule
    ]
})
export class HomeModule { }
